import {Injectable} from '@angular/core';

// @dynamic
@Injectable({
  providedIn: 'root'
})
export class MapTreeStateService {
  private static state: any;

  static save(data) {
    MapTreeStateService.state = data;
  }

  static load() {
    return MapTreeStateService.state;
  }

  static wipe() {
    MapTreeStateService.state = null;
  }
}
